import { useEffect } from 'react'
import { useAppStore } from '../../shared/store/store'

export function usePointOfViewLogic() {
  const pointsOfView = useAppStore((state) => state.pointsOfView)
  const cameraController = useAppStore((state) => state.cameraController)
  const currentPointOfViewIndx = useAppStore((state) => state.currentPointOfViewIndx)
  const defaultCameraConstraints = useAppStore((state) => state.defaultCameraConstraints)
  const isFreeMoveCameraModeEnabled = useAppStore((state) => state.isFreeMoveCameraModeEnabled)

  useEffect(() => {
    if (currentPointOfViewIndx === -1 || pointsOfView.length === 0 || !cameraController) return
    const currentPoint = pointsOfView[currentPointOfViewIndx]
    cameraController.setPointOfView(
      currentPoint,
      defaultCameraConstraints,
      isFreeMoveCameraModeEnabled,
    )
  }, [currentPointOfViewIndx, isFreeMoveCameraModeEnabled])
}
